'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    UserStore = require('../stores/UserStore'),
    EmailFlags = require('../constants/EmailFlags'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    Button = require('../atoms/Button'),
    UserActionCreators = require('../actions/UserActionCreators'),
    { PropTypes } = require('react'),
    { values } = require('underscore');

require('./NotificationSwitchRow.less');

var NotificationSwitchRow = React.createClass({
  mixins: [createStoreMixin(UserStore), PureRenderMixin],

  propTypes: {
    flag: PropTypes.oneOf(values(EmailFlags)).isRequired,
    label: PropTypes.string.isRequired
  },

  getStateFromStores(props) {
    return {
      enabled: UserStore.isEmailNotificationEnabled(props.flag)
    };
  },

  render() {
    var { label } = this.props,
        { enabled } = this.state;

    return (
      <div className='NotificationSwitchRow'>
        <span className='NotificationSwitchRow-label'>
          {label}
        </span>

        <Button onClick={this.handleToggleClick}
                active={enabled}
                switch />
      </div>
    );
  },

  handleToggleClick() {
    var { flag } = this.props,
        { enabled } = this.state;

    if (enabled) {
      UserActionCreators.disableEmailNotification(flag);
    } else {
      UserActionCreators.enableEmailNotification(flag);
    }
  }
});

module.exports = NotificationSwitchRow;



/** WEBPACK FOOTER **
 ** ./molecules/NotificationSwitchRow.jsx
 **/